'use client'

interface StaticNaverMapProps {
  lat: number
  lng: number
  styles?: React.CSSProperties
}

interface StaticNaverMapParams {
  w: number
  h: number
  center: { lat: number; lng: number }
  level: number
  scale: number
  markers: {
    type: string
    size: string
    color: string
    pos: string
    viewSizeRatio: number
  }
  'X-NCP-APIGW-API-KEY-ID': string
}

function StaticNaverMap({ lat, lng, styles }: StaticNaverMapProps) {
  // TODO: w와 h값은 추후 해당 이미지 그려주는 주차장 상세 컴포넌트 완성 후 수정
  const staticMapHost = 'https://maps.apigw.ntruss.com/map-static/v2/raster-cors'
  const naverMapsKey = process.env.NEXT_PUBLIC_NAVER_MAPS_KEY ?? ''

  const params: StaticNaverMapParams = {
    w: 1024, // 이미지 너비 : px단위 0~1024
    h: 200, // 이미지 높이 : px단위 0~1024
    center: { lat, lng }, // 이미지 중심 좌표 : 경도(y), 위도(x) [가운데 콤마로 구분]
    level: 16, // 이미지 줌 레벨 : min: 0, max: 20
    scale: 2, // 이미지 화질 스케일 (min: 1(저화질), max: 2(고화징))
    markers: {
      type: 'd', // 마커 타입 : d(default), n(number), a(alphabet), t(tooltip)
      size: 'mid', // 마커 사이즈 : tiny, small, mid
      color: '0x0099ff', // 마커 컬러
      pos: `${lng} ${lat}`, // 마커 좌표 : 경도(y) 위도(x) [가운데 공백으로 구분]
      viewSizeRatio: 0.5 // 마커 크기 비율 : min: 0.1 max: 2.0 (기본 1.0)
    },
    'X-NCP-APIGW-API-KEY-ID': naverMapsKey
  } satisfies StaticNaverMapParams

  const objectToQueryString = (obj: StaticNaverMapParams): string => {
    return Object.entries(obj)
      .map(([key, value]) => {
        if (typeof value === 'object') {
          if (key === 'center') {
            return `${key}=${value.lng},${value.lat}`
          } else if (key === 'markers') {
            return `${key}=type:${value.type}|size:${value.size}|color:${value.color}|pos:${value.pos}|viewSizeRatio:${value.viewSizeRatio}`
          }
        } else {
          return `${key}=${value}`
        }
      })
      .join('&')
  }

  const queryString = objectToQueryString(params)

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img src={`${staticMapHost}?${queryString}`} alt="지도" style={{ height: '100%', objectFit: 'cover', ...styles }} />
  )
}

export default StaticNaverMap
